import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';

import { useBooleanHandler } from '@mssgme/hooks';
import { Scrollbar, IconButton, Spinner } from '@mssgme/ui';
import { DeprecatedArrowUpIcon } from '@mssgme/icons';

import useHandleError from './useHandleError';

import styles from './MessageInput.scss';

MessageInput.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string.isRequired,
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onEnterPress: PropTypes.func,
    onSubmitClick: PropTypes.func,
};

MessageInput.defaultProps = {
    isFetching: false,
};

export default function MessageInput({
    className,
    value,
    isFetching,
    onChange,
    onEnterPress,
    onSubmitClick,
    children,
    error,
    ...rest
}) {
    const [isFocused, onFocus, onBlur] = useBooleanHandler(false);
    useHandleError(error);

    const handleKeyPress = useCallback(
        (e) => {
            if (!e.shiftKey && e.which === 13) {
                e.preventDefault();
                onEnterPress && onEnterPress(e);
            }
        },
        [onEnterPress]
    );

    const isFilled = !!value.trim();

    return (
        <div className={cn(styles.root, className, { [styles.filled]: isFilled, [styles.focused]: isFocused })}>
            <div className={styles.inputContainer}>
                <Scrollbar>
                    <TextareaAutosize
                        className={styles.input}
                        onChange={onChange}
                        onKeyPress={handleKeyPress}
                        tabIndex="0"
                        value={value}
                        maxLength={2000}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        name="message"
                        {...rest}
                    />
                </Scrollbar>
                <div className={styles.children}>{children}</div>
            </div>
            <div className={cn(styles.btnWrap)}>
                <IconButton className={styles.btn} type="submit" disabled={isFetching} onClick={onSubmitClick}>
                    {isFetching ? (
                        <Spinner color="white" size={24} borderWidth={2} />
                    ) : (
                        <DeprecatedArrowUpIcon size={20} />
                    )}
                </IconButton>
            </div>
        </div>
    );
}
